export const SOURCE_CODE_MODAL_SELECTORS = {
   SOURCE_CODE_TEXTAREA: '#sourceCodeTextarea',
} as const;